import { render, staticRenderFns } from "./ClientMessage.vue?vue&type=template&id=4e61dd78&scoped=true&"
import script from "./ClientMessage.vue?vue&type=script&lang=js&"
export * from "./ClientMessage.vue?vue&type=script&lang=js&"
import style0 from "./ClientMessage.vue?vue&type=style&index=0&id=4e61dd78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61dd78",
  null
  
)

export default component.exports